<template>
  <div class="game-info">
    <div class="header">
      <img src="/Logo.png" alt="Logo" class="logo" />
      <h2>{{ username }} 的游戏信息</h2>
    </div>

    <div class="content">
      <el-card class="game-table" v-loading="isLoading">
        <div class="operation-bar">
          <el-button @click="$router.push('/account-manage')" icon="el-icon-back">返回账号管理</el-button>
          <el-button type="primary" @click="handleAddGame" icon="el-icon-plus">添加游戏</el-button>
        </div>

        <el-table :data="games" style="width: 100%">
          <el-table-column prop="gameId" label="游戏ID" width="100"></el-table-column>
          <el-table-column prop="gameName" label="游戏名称" min-width="150"></el-table-column>
          <el-table-column prop="username" label="用户名" min-width="120"></el-table-column>
          <el-table-column prop="createdAt" label="创建时间" min-width="180">
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleSelectGame(scope.row.gameName)">查看</el-button>
              <el-button type="success" size="small" @click="handleEditGame(scope.row.gameName)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- 游戏弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
        <el-form :model="gameForm" :rules="rules" ref="gameForm" label-width="100px" :disabled="dialogMode === 'view'">
          <el-form-item label="游戏名称" prop="name">
            <el-input v-model="gameForm.name" placeholder="请输入游戏名称" :disabled="dialogMode === 'edit'"></el-input>
          </el-form-item>
          <el-form-item label="AppID" prop="appid">
            <el-input v-model="gameForm.appid" placeholder="请输入AppID"></el-input>
          </el-form-item>
          <el-form-item label="授权类型" prop="grant_type">
            <el-select v-model="gameForm.grant_type" placeholder="请选择授权类型" style="width: 100%">
              <el-option label="client_credential" value="client_credential"></el-option>
            </el-select>
            <el-input 
              v-if="gameForm.grant_type !== 'client_credential'"
              v-model="gameForm.grant_type" 
              placeholder="或输入自定义授权类型"
              style="margin-top: 10px"
            ></el-input>
          </el-form-item>
          <el-form-item label="Secret" prop="secret">
            <el-input v-model="gameForm.secret" placeholder="请输入Secret"></el-input>
          </el-form-item>
          <el-form-item label="登录认证" prop="sidTtDyOpen">
            <el-input v-model="gameForm.sidTtDyOpen" placeholder="请输入登录认证字符串"></el-input>
          </el-form-item>
          <el-form-item label="分成比例" prop="proportion">
            <el-input v-model.number="gameForm.proportion" placeholder="请输入分成比例" suffix="%"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
          <el-button v-if="dialogMode === 'add'" type="primary" @click="submitForm">确 定</el-button>
          <el-button v-if="dialogMode === 'edit'" type="primary" @click="updateForm">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import http from "../api/http";

export default {
  name: "GameInfo",
  data() {
    return {
      isLoading: false,
      games: [],
      username: "",
      dialogVisible: false,
      dialogMode: 'add',
      dialogTitle: '添加游戏',
      gameForm: {
        name: "",
        appid: "",
        grant_type: "client_credential",
        secret: "",
        sidTtDyOpen: "",
        proportion: 0
      },
      rules: {
        name: [
          { required: true, message: "请输入游戏名称", trigger: "blur" }
        ],
        appid: [
          { required: true, message: "请输入AppID", trigger: "blur" }
        ],
        grant_type: [
          { required: true, message: "请选择或输入授权类型", trigger: "blur" }
        ],
        secret: [
          { required: true, message: "请输入Secret", trigger: "blur" }
        ],
        sidTtDyOpen: [
          { required: false, message: "请输入登录认证字符串", trigger: "blur" }
        ],
        proportion: [
          { required: false, message: "请输入分成比例", trigger: "blur" },
          { type: 'number', min: 0, max: 100, message: '分成比例必须在0-100之间', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    fetchGameInfo() {
      this.isLoading = true;
      const username = this.$route.params.username;
      this.username = username;
      
      http.get(`/api/userGames/getUserGames`, {
        params: {
          username: username
        },
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.games = res.data.data;
        } else {
          this.$message.error(res.data.msg || "获取游戏信息失败");
        }
      }).catch(() => {
        this.$message.error("获取游戏信息失败");
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handleAddGame() {
      this.dialogMode = 'add';
      this.dialogTitle = '添加游戏';
      this.dialogVisible = true;
      this.gameForm = {
        name: "",
        appid: "",
        grant_type: "client_credential",
        secret: "",
        sidTtDyOpen: "",
        proportion: 0
      };
    },
    
    handleEditGame(gameName) {
      this.dialogMode = 'edit';
      this.dialogTitle = '编辑游戏';
      this.dialogVisible = true;
      http.get(`/api/appName/appMsg`, {
        params: {
          appName: gameName
        },
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.gameForm = res.data.data;
          this.gameForm.grant_type = res.data.data.grantType; // 适配字段名
        } else {
          this.$message.error(res.data.msg || "获取游戏信息失败");
        }
      }).catch(() => {
        this.$message.error("获取游戏信息失败");
      });
    },
    submitForm() {
      this.$refs.gameForm.validate((valid) => {
        if (valid) {
          http.post(`/api/appName/insertAppName?username=${this.username}`, {
            name: this.gameForm.name,
            appid: this.gameForm.appid,
            grant_type: this.gameForm.grant_type,
            secret: this.gameForm.secret,
            sidTtDyOpen: this.gameForm.sidTtDyOpen,
            proportion: this.gameForm.proportion
          }, {
            headers: {
              "token": `${localStorage.getItem("token")}`
            }
          }).then(res => {
            if (res.data.code === 1) {
              this.$message.success("添加游戏成功");
              this.dialogVisible = false;
              this.fetchGameInfo();
            } else {
              this.$message.error(res.data.msg || "添加游戏失败");
            }
          }).catch(() => {
            this.$message.error("添加游戏失败");
          });
        }
      });
    },
    handleSelectGame(gameName){
      this.dialogMode = 'view';
      this.dialogTitle = '查看游戏';
      this.dialogVisible = true;
      http.get(`/api/appName/appMsg`, {
        params: {
          appName: gameName
        },
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.gameForm = res.data.data;
          this.gameForm.grant_type = res.data.data.grantType;
        } else {
          this.$message.error(res.data.msg || "获取游戏信息失败");
        }
      }).catch(() => {
        this.$message.error("获取游戏信息失败");
      });
    },
    
    updateForm() {
      this.$refs.gameForm.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          // 构建请求体，注意字段名转换，并包含id字段
          // 不包含name字段，因为游戏名称不允许修改
          const updateData = {
            id: this.gameForm.id,
            appid: this.gameForm.appid,
            grantType: this.gameForm.grant_type,
            secret: this.gameForm.secret,
            sidTtDyOpen: this.gameForm.sidTtDyOpen,
            proportion: this.gameForm.proportion
          };
          
          http.put(`/api/appName/update`, updateData, {
            headers: {
              "token": `${localStorage.getItem("token")}`
            }
          }).then(res => {
            if (res.data.code === 1) {
              this.$message.success("更新游戏成功");
              this.dialogVisible = false;
              this.fetchGameInfo();
            } else {
              this.$message.error(res.data.msg || "更新游戏失败");
            }
          }).catch(() => {
            this.$message.error("更新游戏失败");
          }).finally(() => {
            this.isLoading = false;
          });
        }
      });
    },
      // this.gameForm = {
      //   name: gameName,
      //   appid: ,
      //   grant_type: "client_credential",
      //   secret: ""
      // };
  },
  mounted() {
    this.fetchGameInfo();
  }
};
</script>

<style scoped>
.game-info {
  padding: 30px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f6f8fc 0%, #e9ecf4 100%);
}

.header {
  text-align: center;
  margin-bottom: 30px;
  animation: fadeInDown 0.5s ease-out;
}

.logo {
  height: 70px;
  margin-bottom: 15px;
  transition: transform 0.3s;
}

.logo:hover {
  transform: scale(1.05);
}

.header h2 {
  color: #2c3e50;
  font-size: 24px;
  margin: 0;
  font-weight: 500;
}

.content {
  animation: fadeIn 0.5s ease-out;
}

.game-table {
  border-radius: 12px;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.game-table :deep(.el-card__body) {
  padding: 20px;
}

.operation-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.dialog-footer {
  text-align: right;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>